module.exports = __webpack_public_path__ + "img/result-top.6f36a5b4.png";